import { SemanticCOLORS } from "semantic-ui-react";
import { InspectionStatus } from "./InspectionStatus";

export const InspectionStatusColor: Record<InspectionStatus, SemanticCOLORS | undefined> = {
  unscheduled: undefined,
  scheduled: "blue",
  passed: "green",
  failed: "red",
  requested: undefined,
  started: "blue",
} as const;
